window.CartDiscount = (() => {
  function isSellingPlanItem(item) {
    return Boolean(
      item.selling_plan_allocation ||
      item.selling_plan_id ||
      item.properties?._selling_plan ||
      item.properties?.selling_plan
    );
  }

  function getEligibleVariantIds() {
    return new Set(
      (window.TT_BUNDLE_ELIGIBLE_VARIANT_IDS || [])
        .map(Number)
        .filter(Boolean)
    );
  }

  function getDiscountPercent(count) {
    if (count >= 5) return 25;
    if (count >= 4) return 20;
    if (count >= 3) return 15;
    return 0;
  }

  function getProgressPercent(count) {
    if (count <= 0) return 0;
    if (count === 1) return 20;
    if (count === 2) return 40;
    if (count === 3) return 60;
    if (count === 4) return 80;
    return 100;
  }

  function getActiveTier(count) {
    if (count >= 5) return 5;
    if (count >= 4) return 4;
    if (count >= 3) return 3;
    return null;
  }

  function boxLabel(count) {
    return count === 1 ? 'box' : 'boxes';
  }

  function getCartCount(cart) {
    const eligibleVariantIds = getEligibleVariantIds();

    return (cart.items || []).reduce((total, item) => {
      if (isSellingPlanItem(item)) return total;
      if (!eligibleVariantIds.has(Number(item.variant_id))) return total;

      return total + item.quantity;
    }, 0);
  }

  function getState(count) {
    const discountPercent = getDiscountPercent(count);
    const activeTier = getActiveTier(count);
    const progressPercent = getProgressPercent(count);

    let message = '';

    if (count < 3) {
      const remaining = 3 - count;
      message = `Add ${remaining} more ${boxLabel(remaining)} to unlock 15% off`;
    } else {
      message = `${count} eligible ${boxLabel(count)} · ${discountPercent}% off unlocked`;
    }

    return {
      count,
      discountPercent,
      activeTier,
      progressPercent,
      message,
      isUnlocked: count >= 3
    };
  }

  function renderProgress(state, rootEl) {
    if (!rootEl) return;

    const fill = rootEl.querySelector('[data-cart-progress-fill]');
    const markers = rootEl.querySelectorAll('[data-tier-step]');
    const labels = rootEl.querySelectorAll('[data-tier-label]');

    if (fill) {
      fill.style.width = `${state.progressPercent}%`;
    }

    markers.forEach((marker) => {
      const step = Number(marker.dataset.tierStep);
      marker.classList.toggle('is-complete', state.count >= step);
      marker.classList.toggle('is-active', step === state.activeTier);
    });

    labels.forEach((label) => {
      const step = Number(label.dataset.tierLabel);
      label.classList.toggle('is-complete', state.count >= step);
      label.classList.toggle('is-active', step === state.activeTier);
    });
  }

  function renderMessage(state, el) {
    if (!el) return;
    el.textContent = state.message;
  }

  function renderAll(cart) {
    const trackers = document.querySelectorAll('[data-cart-discount-progress]');
    if (!trackers.length) return;

    const count = getCartCount(cart);
    const state = getState(count);

    trackers.forEach((rootEl) => {
      const messageEl = rootEl.querySelector('[data-cart-discount-message]');
      renderProgress(state, rootEl);
      renderMessage(state, messageEl);
    });
  }

  async function fetchCart() {
    if (window.TTCart?.fetchCart) {
      return window.TTCart.fetchCart();
    }

    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Failed to fetch cart');
    }

    return await res.json();
  }

  async function sync(cart = null) {
    const currentCart = cart || await fetchCart();
    renderAll(currentCart);
  }

  function init() {
    if (window.__ttCartDiscountInitialized) return;
    window.__ttCartDiscountInitialized = true;

    sync();

    document.addEventListener('cart:change', (event) => {
      if (event?.detail?.cart) {
        renderAll(event.detail.cart);
      } else {
        sync();
      }
    });

    document.addEventListener('cart:refresh', () => {
      sync();
    });

    document.addEventListener('shopify:section:load', () => {
      sync();
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return {
    getDiscountPercent,
    getProgressPercent,
    getActiveTier,
    getCartCount,
    getState,
    renderProgress,
    renderMessage,
    renderAll,
    sync,
    init,
    isSellingPlanItem,
    getEligibleVariantIds
  };
})();